import React from 'react'
import Day from './components/Day'
import { useResourcesByDate } from '../../hooks'
import DaysOfTheWeek from './components/DaysOfTheWeek'
import { ClipLoader } from 'react-spinners'

export default function MonthView() {
  const { currentDate, isFetchingResources, resourcesSortedByDate } = useResourcesByDate()

  return (
    <div style={{width: '100%', height: 'calc(100% - 77px)', overflowY: 'hidden', backgroundColor: 'rgba(0,0,0,0.03)'}}>
      {
        isFetchingResources ?
        <div className="d-flex w-100 h-100 align-items-center justify-content-center"><ClipLoader color="#20a8d8"/></div> :
        <>
          <DaysOfTheWeek/>
          <div style={{overflowY: 'scroll', height: 'calc(100% - 38px)' }}>
            { resourcesSortedByDate.map( (item, index) =>(<Day index={index} currentDate={currentDate} key={item.date} { ...item } />)) }
          </div>
        </>
      }
    </div>
  )
}